import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";

export default class ButtonUnderlineText extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {text, textColor = Colors.Text.White, textHoverColor}) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.isLocked = false

        this.textColor = textColor
        this.textHoverColor = textHoverColor

        this.addBody({text, textColor})        
        // Ajout intéractions
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', () => {
            this.pointerOver()
        })

        this.on('pointerout', () => {
            this.pointerOut()
        })
    }

    setClickFunction( clickFunction ){
        this.on('pointerup', () => {
            this.scene.tweens.add({
                targets: this,
                scale: 0.9,
                duration: 100,
                yoyo: true,
                ease: 'Cubic.easeInOut',
                onComplete: () => {
                    clickFunction(this);
                }
            })
        }, this.scene);
    }

    // -- A completer dans les class enfants

    addBody({text, textColor}){
        this.textElmt = this.scene.add.rexTagText(0, 0, text, {
            fontFamily: FONTS.Inter18Italic,
            fontSize: '18px',
            backgroundColor: "transparent",
            color: textColor,
            underline: {
                color: textColor,
                thickness: 2,
                offset: 6
            }
        });
        this.textElmt.setOrigin(0.5);
        this.add(this.textElmt);

        this.setSize(this.textElmt.width, this.textElmt.height);
    }

    pointerOver(){
        if(this.textHoverColor){
            this.scene.tweenTextColor(this.textElmt, this.textHoverColor, 200);
            this.textElmt.setUnderlineColor(this.textHoverColor);
        }
    }

    pointerOut(){
        if(this.textHoverColor){
            this.textElmt.setUnderlineColor(this.textColor);
            this.scene.tweenTextColor(this.textElmt, this.textColor, 200);
        }
    }

    setLocked(){
        // Ajout de l'état bloqué
        this.isLocked = true
    }

    setUnlocked(){
        // Ajout de l'état débloqué
        this.isLocked = false
    }
}